export default function getCurrrentCompanyCode(): string {
  if (process.env.REACT_APP_DEPLOYED_DOMAIN) {
    return process.env.REACT_APP_DEPLOYED_DOMAIN;
  }
  if (window.location.hostname === "localhost") {
    return "pluto-psms-webapp.web.app";
  }
  return window.location.hostname;
}
